/**
 * FORMAT-DATE.UTILS
 * Replace occurence for email
 */

import i18next from "i18next"
import { store } from "@/index"
import { DEFAULT_FILTERS } from "@/redux/filter.types"
import { getCompanyFilterName } from "@/utils/observer-scope-options.utils"

const getFilterName = (filterName: string) => {

  if (filterName === "company") {
    return getCompanyFilterName(store.getState()._session)
  } else if (DEFAULT_FILTERS.map((x: any) => x.id).includes(filterName)) {
    return i18next.t("user_" + filterName + "_alt")
  } else {
    return filterName
  }

}

export default getFilterName

